export const GET_BIRTHDAY_WIDGET_LIST = 'BIRTHDAY_WIDGET/GET_BIRTHDAY_WIDGET_LIST'
export const GET_BIRTHDAY_WIDGET_LIST_SUCCESS = 'BIRTHDAY_WIDGET/GET_BIRTHDAY_WIDGET_LIST_SUCCESS'
export const GET_BIRTHDAY_WIDGET_LIST_FAILED = 'BIRTHDAY_WIDGET/GET_BIRTHDAY_WIDGET_LIST_FAILED'

export const CLEAR_BIRTHDAY_WIDGET_LIST = 'BIRTHDAY_WIDGET/CLEAR_BIRTHDAY_WIDGET_LIST'
